import { legacy } from '@/shared/api/client';
import { useQuery } from '@tanstack/react-query';

export interface VarejoOnlineSettings {
  active: boolean;
  configured: boolean;
  enabled: boolean;
  pending: number;
  failed: number;
}

/** Estado da fila de terceiros desta loja (GET /passbook/:id/varejonline). */
export function useVarejoOnlineSettings(idPassbook: string) {
  return useQuery({
    queryKey: ['varejonline-settings', idPassbook],
    queryFn: () =>
      legacy.get<VarejoOnlineSettings>(`/passbook/${idPassbook}/varejonline`, {
        headers: { 'X-Passbook-Id': idPassbook },
      }),
    enabled: Boolean(idPassbook),
  });
}

/** Liga ou desliga o envio de cadastro desta loja. Não enfileira a base. */
export async function updateVarejoOnlineSettings(idPassbook: string, active: boolean): Promise<void> {
  await legacy.put<{ ok: boolean }>(
    `/passbook/${idPassbook}/varejonline`,
    { active },
    { headers: { 'X-Passbook-Id': idPassbook } },
  );
}
